import {
    SET_LOADING_RATING_APPLICANTS,
    SET_LOADED_RATING_APPLICANTS,
    SET_RATING_APPLICANTS_LINKS,
} from '../store/actionTypes';

export const isLoadedRatingApplicants = (state = false, action) => {
    switch (action.type) {
        case SET_LOADING_RATING_APPLICANTS:
            return false;
        case SET_LOADED_RATING_APPLICANTS:
            return true;
        default:
            return state;
    }
};

export const ratingApplicantsLinks = (state = [], action) => {
    switch (action.type) {
        case SET_RATING_APPLICANTS_LINKS:
            return action.payload;
        default:
            return state;
    }
};
